import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Chapter, Project, ProjectVersion } from '@simultrain/shared';
import { api } from '../api/client.js';

export function ProjectDetailPage() {
  const { t } = useTranslation();
  const { projectId } = useParams<{ projectId: string }>();
  const nav = useNavigate();
  const [project, setProject] = useState<(Project & { versions: ProjectVersion[] }) | null>(null);
  const [chapters, setChapters] = useState<Chapter[]>([]);

  useEffect(() => {
    if (!projectId) return;
    void (async () => {
      const p = await api.getProject(projectId);
      setProject(p);
      const v = p.versions.find((x) => x.status === 'published') ?? p.versions[0];
      if (v) setChapters(await api.listChapters(v.id));
    })();
  }, [projectId]);

  if (!project) return <div className="empty">…</div>;

  return (
    <div className="main">
      <Link to="/" style={{ fontSize: 13, color: 'var(--muted)' }}>
        ← {t('projects.title')}
      </Link>
      <h2 style={{ marginTop: 12, marginBottom: 4 }}>{project.name}</h2>
      {project.description && (
        <div className="muted" style={{ marginBottom: 24 }}>{project.description}</div>
      )}

      <h3 style={{ marginBottom: 12 }}>{t('chapters.title')}</h3>
      {chapters.length === 0 && (
        <div className="empty">Geen hoofdstukken beschikbaar.</div>
      )}
      {chapters.map((c) => (
        <div className="chapter-card" key={c.id}>
          <div className="muted">{t('chapters.ordinal', { n: c.ordinal + 1 })} · v{c.versionLabel}</div>
          <h3>{c.title}</h3>
          {c.description && <div className="muted">{c.description}</div>}
          <div className="chapter-modes">
            <button
              style={{ background: '#0284c7' }}
              onClick={() => nav(`/run/${c.id}/instruction`)}
            >
              {t('chapters.instructionMode')}
            </button>
            <button
              style={{ background: '#7c3aed' }}
              onClick={() => nav(`/run/${c.id}/training`)}
            >
              {t('chapters.trainingMode')}
            </button>
            <button
              style={{ background: '#b45309' }}
              onClick={() => nav(`/run/${c.id}/test`)}
            >
              {t('chapters.testMode')}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
